import React from 'react'
import styles from "./Profile.module.scss"
import { Formik } from 'formik';
import * as Yup from "yup";
import ProfileForm from './ProfileForm';
import { useDispatch, useSelector } from 'react-redux';
import { setuserProfile } from '@redux/slices/globalSlice';
import { useFormHandler } from '../hierarchy/hooks/useFormHandler';
import { USER } from 'services/apiEndpoints';
import { getUserData } from 'utils/utils';
import { throttle } from 'lodash';


const email = localStorage.getItem("email")
    ? localStorage.getItem("email")
    : "user@gmail.com";

const validationSchema = Yup.object({
    firstName: Yup.string().required("First Name is required"),
    lastName: Yup.string().required("Last Name is required"),
    email: Yup.string().matches(
        /^[A-Z0-9._%+-]+@[A-Z.-]+\.[A-Z]{2,}$/i,
        'Invalid email format'
    ).required("Email is required"),
    timeZone: Yup.string(),
})

const CreateProfile = () => {
    const { updateDetails } = useFormHandler();
    const dispatch = useDispatch();
    const userProfile = useSelector(state => state.global.userProfile)
    const id = getUserData("userId");


    const initialValues = {
        firstName: "",
        lastName: "",
        email: email,
        phone: "",
        userProfile: userProfile
    };

    const throttledSubmit = throttle(async (values, existingUser, id, updateDetails, dispatch, setSubmitting) => {
        try {
            await updateDetails(USER, id, { ...values, userProfile: values.userProfile }, "Profile");
            localStorage.setItem(
                "currentUser",
                JSON.stringify({
                    ...existingUser,
                    userProfile: values.userProfile
                })
            );
            dispatch(setuserProfile(values?.userProfile));
        } catch (error) {
            console.log('error', error);
        } finally {
            setSubmitting(false);
        }
    }, 2000);

    const handleSubmit = async (values, setSubmitting) => {
        const existingUser = JSON.parse(localStorage.getItem("currentUser")) || {};
        throttledSubmit(values, existingUser, id, updateDetails, dispatch, setSubmitting);
    };

    return (
        <>
            <div className={styles?.mainContainer}>
                <Formik
                    initialValues={initialValues}
                    validateOnChange={false}
                    validateOnBlur={false}
                    validationSchema={validationSchema}
                    onSubmit={(values, { setSubmitting }) => {
                        handleSubmit(values, setSubmitting);
                    }}

                >
                    {
                        (formik) => {
                            return <ProfileForm />
                        }
                    }
                </Formik>
            </div>
        </>
    )
}

export default CreateProfile

